import { MutationFunction, useMutation, useQueryClient } from 'react-query';
import { QueryKeySet } from './createQueryKeySet';

interface Params<TData, TVariables> {
  mutationFunc: MutationFunction<TData, TVariables>;
  keySet: QueryKeySet;
}

export const createCreateMutationHook =
  <TData, TVariables>({ mutationFunc, keySet }: Params<TData, TVariables>) =>
  () => {
    const queryClient = useQueryClient();

    return useMutation(mutationFunc, {
      onSuccess() {
        queryClient.invalidateQueries(keySet.lists());
      },
    });
  };
